import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AtsList, Candidate, Comment } from './candidate';

@Injectable({
  providedIn: 'root'
})
export class CandidateService {
  
  private apiServerUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient){}

  public submitApplication(candidate: Candidate): Observable<Candidate> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem('token')}`);
    return this.http.post<Candidate>(`https://talentmarket.io/api/public/submit`, candidate);
  }

  public uploadCandidateCv(candidateId: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(
      `${this.apiServerUrl}/public/candidate/${candidateId}/cv`, formData
    );
  }

  public getCandidateApplication(id: number): Observable<Candidate> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem('token')}`);
    return this.http.get<Candidate>(`${this.apiServerUrl}/quiz/a/${id}`,{ headers });
  }

  public candidateDescription(id: number, description: string): Observable<Candidate> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem('token')}`);
    return this.http.put<Candidate>(`${this.apiServerUrl}/quiz/save/description/${id}`, description, { headers });
  }
  public addComment(id: number, comment: Comment): Observable<Candidate> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem('token')}`);
    return this.http.post<Candidate>(`${this.apiServerUrl}/quiz/save/comment/${id}`, comment , { headers });
  }

  public moveInNewList(atslists: AtsList[]): Observable<AtsList[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem('token')}`);
    return this.http.put<AtsList[]>(`${this.apiServerUrl}/quiz/candidate/move`,atslists, { headers });
}
/*
public moveInSameList(cand: AtsList): Observable<AtsList> {
  const headers = new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem('token')}`);
  return this.http.put<AtsList>(`${this.apiServerUrl}/quiz/ats/moveinnew`,candidates, { headers });
}*/
}
